import cn from 'classnames';
import {useMemo, useState} from 'react';

interface DescriptionData {
  description?: string;
  combinations?: string;
  application_method?: string;
}

interface Props {
  data: DescriptionData;
}

const TAB_LABELS: Record<keyof DescriptionData, string> = {
  description: 'توضیحات',
  combinations: 'ترکیبات',
  application_method: 'روش مصرف',
};

export const DescriptionView = ({data}: Props) => {
  // generate list of only fields that actually have value
  const tabs = useMemo(() => {
    return (Object.keys(TAB_LABELS) as (keyof DescriptionData)[])
      .filter(key => Boolean(data[key]))
      .map(key => ({
        id: key,
        label: TAB_LABELS[key],
        content: data[key]!,
      }));
  }, [data]);

  const [activeId, setActiveId] = useState(tabs[0]?.id);

  const activeTab = tabs.find(t => t.id === activeId);

  return (
    <div className="w-full">
      {/* Tabs */}
      <div className="flex gap-4 px-3 border-b">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveId(tab.id)}
            className={cn(
              'py-3 rounded-t-md text-md font-medium',
              activeId === tab.id
                ? 'text-lime-600 border-b-2 border-lime-600'
                : 'text-neutral-600 border-b-2 border-transparent',
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div
        className="overflow-y-auto p-3 mb-4 max-h-40 leading-relaxed text-gray-900 whitespace-pre-wrap rounded-md"
        style={{
          direction: 'rtl',
          textAlign: 'justify',
          textAlignLast: 'right',
        }}
      >
        {activeTab?.content}
      </div>
    </div>
  );
};
